import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { ChevronDown, Globe2, Menu, PhoneCall, UserRound, X } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import type { Language } from '../types'

type Props = {
  language: Language
  announcement: string
  onLanguageChange: (value: Language) => void
  onLogin: () => void
}

export function Header({ language, announcement, onLanguageChange, onLogin }: Props) {
  const [open, setOpen] = useState(false)
  const { user } = useAuth()
  const links = language === 'hi'
    ? [['/', 'होम'], ['/astrologers', 'ज्योतिषी'], ['/how-it-works', 'कैसे काम करता है'], ['/dashboard', 'मेरी बुकिंग']]
    : [['/', 'Home'], ['/astrologers', 'Astrologers'], ['/how-it-works', 'How it works'], ['/dashboard', 'My bookings']]

  return <>
    <div className="trust-bar"><span>✦ {announcement}</span></div>
    <header className="site-header">
      <Link to="/" className="brand" aria-label="Mokshm home">
        <img src="/mokshm-logo.png" alt="Mokshm" />
      </Link>
      <nav className={`main-nav ${open ? 'is-open' : ''}`}>
        {links.map(([to, label]) => <NavLink key={to} to={to} onClick={() => setOpen(false)}>{label}</NavLink>)}
        <Link to="/astrologer-portal" onClick={() => setOpen(false)}>{language === 'hi' ? 'ज्योतिषी लॉगिन' : 'Astrologer login'}</Link>
      </nav>
      <div className="header-actions">
        <div className="language-switch">
          <Globe2 size={16} />
          <select value={language} onChange={(e) => onLanguageChange(e.target.value as Language)} aria-label="Language">
            <option value="hi">हिंदी</option>
            <option value="en">English</option>
          </select>
          <ChevronDown size={14} />
        </div>
        <a href="tel:+910000000000" className="icon-button desktop-only" aria-label="Support"><PhoneCall size={19} /></a>
        <button className="login-button" onClick={onLogin}>
          <UserRound size={17} /> {user ? (language === 'hi' ? 'मेरा खाता' : 'My account') : (language === 'hi' ? 'लॉगिन' : 'Login')}
        </button>
        <button className="menu-button" onClick={() => setOpen(!open)} aria-label="Menu">{open ? <X /> : <Menu />}</button>
      </div>
    </header>
  </>
}
